import { motion } from "framer-motion";

const Motion = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      style={{ transformOrigin: "left" }}
    >
      {children}
    </motion.div>
  );
};

export default Motion;
